(()=>{
  function replaceStickerThumbnail(row){
    const preview=row.querySelector('.product-option--artwork-preview .artwork-order-preview');
    const thumbnail=row.querySelector('.cart-item__image');
    if(!preview||!thumbnail)return;

    const previewUrl=String(preview.getAttribute('src')||'').trim();
    if(!previewUrl)return;

    if(thumbnail.dataset.opsArtworkPreview!==previewUrl){
      thumbnail.src=previewUrl;
      thumbnail.alt='Your artwork preview';
      thumbnail.dataset.opsArtworkPreview=previewUrl;
      thumbnail.closest('.cart-item__image-container')?.classList.add('ops-cart-artwork-thumbnail');
    }

    const duplicatePreview=preview.closest('.product-option--artwork-preview');
    if(duplicatePreview&&!duplicatePreview.hidden)duplicatePreview.hidden=true;
  }

  function updateMakerLink(row,isMakerProject){
    if(!isMakerProject)return;
    const makerLink=row.querySelector('.ops-cart-configured-quantity a[href]');
    if(!makerLink)return;

    const href=String(makerLink.getAttribute('href')||'');
    const isSavedProject=/(?:\?|&)opsProject=/.test(href);
    const wantedLabel=isSavedProject?'Open saved project':'Open in Maker';
    if(makerLink.textContent!==wantedLabel)makerLink.textContent=wantedLabel;
    makerLink.classList.add('ops-cart-maker-link');
  }

  function enhanceStickerRows(){
    document.querySelectorAll('.cart-item').forEach(row=>{
      const titleLink=row.querySelector('.cart-item__name');
      if(!titleLink)return;
      const href=String(titleLink.getAttribute('href')||'');
      const title=String(titleLink.textContent||'');
      if(!href.includes('/products/custom-stickers')&&!/Custom Die Cut Stickers/i.test(title))return;

      replaceStickerThumbnail(row);

      let label=row.querySelector('.ops-cart-source-label');
      if(!label){
        label=document.createElement('span');
        label.className='ops-cart-source-label';
        const titleWrap=row.querySelector('.cart-item__title')||titleLink.parentElement;
        if(titleWrap)titleWrap.insertAdjacentElement('afterend',label);
      }

      const isMakerProject=Boolean(row.querySelector('.ops-cart-configured-quantity'));
      const wantedLabel=isMakerProject?'Made with Maker':'Quick Buy';
      const wantedSource=isMakerProject?'maker':'quick-buy';
      if(label.textContent!==wantedLabel)label.textContent=wantedLabel;
      if(label.dataset.source!==wantedSource)label.dataset.source=wantedSource;
      updateMakerLink(row,isMakerProject);
    });

    if(!document.getElementById('ops-cart-source-label-style')){
      const style=document.createElement('style');
      style.id='ops-cart-source-label-style';
      style.textContent=`
        .ops-cart-source-label{display:inline-flex;align-items:center;width:max-content;margin:.45rem 0 .55rem;padding:.32rem .62rem;border:1px solid rgba(20,20,20,.18);border-radius:999px;background:#fff;color:#191919;font-size:1.05rem;font-weight:700;line-height:1;letter-spacing:.02em}
        .ops-cart-source-label[data-source="maker"]{border-color:#8f1d2c;color:#8f1d2c}
        .ops-cart-artwork-thumbnail{background:#f2f2f2}
        .ops-cart-artwork-thumbnail .cart-item__image{width:100%;height:100%;object-fit:contain}
        .ops-cart-maker-link{font-weight:700}
      `;
      document.head.appendChild(style);
    }
  }

  let enhanceQueued=false;
  function queueEnhance(){
    if(enhanceQueued)return;
    enhanceQueued=true;
    requestAnimationFrame(()=>{enhanceQueued=false;enhanceStickerRows()});
  }

  async function removeConfigured(button){
    if(button.disabled)return;button.disabled=true;const label=button.textContent;button.textContent='Removing…';
    try{
      const group=String(button.dataset.groupId||''),lineKey=String(button.dataset.lineKey||'');
      const updates={};
      if(group){const cart=await fetch(`${window.Shopify?.routes?.root||'/'}cart.js`,{headers:{Accept:'application/json'},cache:'no-store'}).then(r=>r.json());for(const item of cart.items||[]){if(String(item.properties?.['_OPS group id']||'')===group)updates[item.key]=0}}
      else if(lineKey)updates[lineKey]=0;
      if(!Object.keys(updates).length)throw new Error('We could not find that basket item.');
      const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates})});
      if(!response.ok)throw new Error('The item could not be removed.');
      window.location.assign(`${window.Shopify?.routes?.root||'/'}cart`);
    }catch(error){console.error(error);button.disabled=false;button.textContent=label;window.alert('We couldn’t remove that item. Please refresh the basket and try again.')}
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',queueEnhance,{once:true});
  else queueEnhance();
  document.addEventListener('shopify:section:load',queueEnhance);
  new MutationObserver(queueEnhance).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('click',event=>{const button=event.target.closest('[data-ops-remove-configured]');if(button){event.preventDefault();removeConfigured(button)}});
})();